export function sanitizeCnpjInput(raw) {
  const cleaned = String(raw).replace(/[^A-Za-z0-9]/g, '').toUpperCase()
  return cleaned.slice(0, 12) + cleaned.slice(12).replace(/\D/g, '').slice(0, 2)
}

export function getCnpjCleaveOptions() {
  return {
    delimiters: ['.', '.', '/', '-'],
    blocks: [2, 3, 3, 4, 2],
    numericOnly: false,
    uppercase: true,
    onValueChanged(e) {
      const cleaned = String(e.target.rawValue).replace(/[^A-Za-z0-9]/g, '').toUpperCase()
      const sanitized = sanitizeCnpjInput(cleaned)

      if (sanitized !== cleaned) {
        this.cleave.setRawValue(sanitized)
        this.$emit('input', this.raw ? sanitized : this.$el.value)
      }
    },
  }
}

export function onCnpjKeydown(event) {
  const { key, target } = event

  if (key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey) return

  const rawIndex = target.value
    .slice(0, target.selectionStart)
    .replace(/[^A-Za-z0-9]/g, '')
    .length

  if (rawIndex >= 12 && !/\d/.test(key)) {
    event.preventDefault()
  }
}
